import { Reveal } from "@/components/Reveal";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1647776112336-72f4c30fafc1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxiYXJ0ZW5kZXIlMjBtaXhpbmclMjBkcmluayUyMGRhcmt8ZW58MHx8fHwxNzkxMjE2MzY3fDA&ixlib=rb-4.1.0&q=85";

const STEPS = [
  {
    n: "01",
    title: "Pick your package & date",
    body: "Reserve online with a deposit. Your date is locked the moment it clears.",
  },
  {
    n: "02",
    title: "We design your bar",
    body: "A custom cocktail menu, a supply list and every ice cube — handled before you lift a finger.",
  },
  {
    n: "03",
    title: "We pour, you host",
    body: "Setup, service and full teardown. You'll never see a lukewarm bottle or an empty glass.",
  },
];

export default function About() {
  return (
    <section id="about" className="py-24 md:py-32">
      <div className="mx-auto max-w-7xl px-5 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-start">
        <div className="lg:col-span-5">
          <Reveal>
            <div className="overflow-hidden border border-white/10" data-testid="about-image-frame">
              <img
                src={ABOUT_IMG}
                alt="Bartender building a cocktail at a dark bar"
                className="w-full aspect-[3/4] object-cover hover:scale-105 transition-transform duration-700 will-change-transform"
              />
            </div>
          </Reveal>
        </div>

        <div className="lg:col-span-7">
          <Reveal>
            <p className="eyebrow mb-5">About Estielle</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.02] text-[#F5F5F5]">
              A craft cocktail bar that <em className="italic text-[#D98B48]">travels</em> to your door.
            </h2>
            <p className="mt-6 max-w-xl text-[#A3A3A3] font-light leading-relaxed">
              Estielle is a mobile bartending studio. We build a full bar wherever
              your event lives — a backyard, a loft, a rooftop, a ballroom — and
              staff it with people who take the craft seriously. Same care, same
              garnish, wherever you gather.
            </p>
          </Reveal>

          <div className="mt-12">
            {STEPS.map((s, i) => (
              <Reveal key={s.n} delay={i * 0.08}>
                <div className="flex gap-6 md:gap-10 border-t border-white/10 py-7 last:border-b" data-testid={`about-step-${s.n}`}>
                  <span className="font-display italic text-2xl md:text-3xl text-[#C5A059] w-10 shrink-0">{s.n}</span>
                  <div>
                    <h3 className="text-lg md:text-xl text-[#F5F5F5] font-medium">{s.title}</h3>
                    <p className="mt-2 text-sm text-[#A3A3A3] font-light leading-relaxed max-w-lg">{s.body}</p>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
